import { Outlet, useParams } from "react-router";
import { TabNav } from "@/components/TabNav";

const tabs = [{ label: "Claude", to: "claude" }];

export function AiLayout() {
  const { orgId } = useParams();

  return (
    <div className="mx-auto max-w-3xl text-foreground">
      <div className="mb-4">
        <h1 className="text-2xl font-semibold tracking-tight">AI</h1>
        <p className="mt-0.5 text-sm text-foreground/70">
          Connect AI providers to record your organization's conversations
        </p>
      </div>

      <TabNav tabs={tabs} basePath={`/${orgId}/ai`} />

      <Outlet />
    </div>
  );
}
